module.exports = __webpack_public_path__ + "img/07.a4be2e2d.jpg";